<template lang="pug">
  v-container
    v-container(fluid='')
      v-toolbar(color='primary' dark='')
        span {{ branchName }}
      div(style='position: relative')
        v-overlay(:value='loadingServerSideData' absolute='' color='primary')
          .text-h1.w-100 Loading...
        sales-chart(
          :graph-data-purchases='rcvInvList'
          :graph-data-sales='saleInvList'
          :graph-data-losts='lostInvList'
          :graph-data-loan-txn='cxLoanTxnList'
          :graph-data-loan-inv='cxLoanInvList'
          :graph-setting='dateIntervalSelected'
          :graph-data-expense='expenseList'
          :date='graphDate'
          style='height: 300px'
        )
    v-row
      v-col(lg='6' cols='12')
        v-item-group(v-model='dateIntervalSelected' mandatory='')
          v-item(v-for='(item, index) in dateIntervalItems' :key='index')
            template(v-slot='{ active, toggle }')
              v-chip.text-capitalize.mr-2(color='primary' @click='toggle' :outlined='!active')
                v-avatar.white--text.text-uppercase(left='' color='blue' v-text='item.slice(0, 1)')
                |                 {{ item }}
        v-date-picker.mt-2(color='primary' full-width='' v-model='graphDate')
      v-col(lg='6' cols='12')
        v-row
          v-col.pa-2.mb-0(cols='12')
            v-card
              v-toolbar(color='primary' dark dense flat)
                span Expense Category
              v-container
                v-autocomplete(
                  label='Expense Category'
                  v-model='expenseCategory'
                  :items='expenseCategoryList'
                  item-value='id'
                  item-text='description'
                  :clearable='Boolean(expenseCategory)'
                )
            base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntervalSelected].replace('ly', '')} Net Profit`" :value='netProfit.phpFormat()')
            v-row
              v-col.pa-2.mb-0(cols='6' lg='6')
                base-material-stats-card.text-capitalize(color='primary' icon='mdi-currency-usd' :title="`${dateIntervalItems[dateIntervalSelected].replace('ly', '')} Sales`" :value='rangeSales.phpFormat()')
                base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntervalSelected].replace('ly', '')} Expenses`" :value='rangeExpenses.phpFormat()')
                base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntervalSelected].replace('ly', '')} Loan Paid`" :value='rangeLoanPaid.phpFormat()')
              v-col.pa-2.mb-0(cols='6' lg='6')
                base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntervalSelected].replace('ly', '')} Purchases`" :value='rangeRecieved.phpFormat()')
                base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntervalSelected].replace('ly', '')} Loan Lent`" :value='rangeLoanLent.phpFormat()')
                base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntervalSelected].replace('ly', '')} Collectibles`" :value='collectibles.phpFormat()')
</template>
<script>
  import { mapState } from 'vuex'
  // import searchDelay from '@/extra-functions/searchDelay.extra'
  import rcvInvRepository from '@/repositories/recieved-inventory.repository'
  import saleInvRepository from '@/repositories/sale-inventory.repository'
  import lostInvRepository from '@/repositories/lost-inventory.repository'
  import cxLoanTxnRepository from '@/repositories/consumer-loan-transaction.repository'
  import cxLoanInvRepository from '@/repositories/consumer-loan-inventory.repository'
  import { moneyMixin } from '@/views/dashboard/mixins/helper.mixins'
  import { apiVars, intervalGetters } from '@/extra-functions/api-helper.extra'
  import { errorHandler } from '@/extra-functions/store.extra'
  import VueRequestHandler from '@/classes/VueRequestHandler.class'
  import requestVars from '@/extra-functions/request-vars.extra'
  import expenseRepository from '@/repositories/expense.repository'
  import expenseCategoryRepository from '@/repositories/expense-category.repository'

  const [expenseGetVars, expenseGetVarNames] = requestVars({ identifier: 'expense' })
  const [expenseCategoryGetVars, expenseCategoryGetVarNames] = requestVars({ identifier: 'expense-category' })

  const expenseGetHandler = new VueRequestHandler(null, expenseGetVarNames)
  const expenseCategoryGetHandler = new VueRequestHandler(null, expenseCategoryGetVarNames)

  function internalGetterCallBack (c) {
    return function (date) {
      this[c.loadingName] = true
      c.delay(() => {
        c.repository[`${c.suffix.toLowerCase()}Branch`](this.storeId, { date })
          .then(({ data }) => { this[c.listName] = data })
          .catch(e => { this[c.errorName] = errorHandler(e) })
          .then(() => { this[c.loadingName] = false })
      })
    }
  }

  function getCurrentDate () {
    const date = new Date()
    const year = date.getFullYear()
    const month = (`${date.getMonth() + 1}`).padStart(2, '0')
    const day = (`${date.getDate()}`).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  function dateIntervalVariables () {
    const identifier = 'dateInterval'
    return {
      [`${identifier}Selected`]: 1,
      [`${identifier}Items`]: ['weekly', 'monthly', 'yearly'],
    }
  }

  // const cxLoanTxnUpdateDelay = searchDelay(1000)
  // const lostInvUpdateDelay = searchDelay(1000)
  // const saleInvUpdateDelay = searchDelay(1000)
  // const rcvInvUpdateDelay = searchDelay(1000)
  // const cxLoanInvUpdateDelay = searchDelay(1000)

  export default {
    name: 'ShowStore',
    components: {
      salesChart: () => import('@/views/dashboard/component/SalesChart'),
    },
    data () {
      return {
        ...apiVars('cxLoanTxn'),
        ...apiVars('rcvInv'),
        ...apiVars('saleInv'),
        ...apiVars('lostInv'),
        ...apiVars('cxLoanInv'),
        ...dateIntervalVariables(),
        ...expenseGetVars,
        ...expenseCategoryGetVars,
        loadingGraphData: false,
        graphDate: null,
        settings: 0,
        expenseCategory: {},
      }
    },
    created () {
      this.graphDate = getCurrentDate()
      this.getGraphData()
      this.getExpenseCategories()
    },
    computed: {
      ...mapState({
        lostInvUpdated: state => state.lostInventory.channelUpdate,
        saleInvUpdated: state => state.saleInventory.channelUpdate,
        rcvInvUpdated: state => state.recievedInventory.channelUpdate,
        cxLoanTxnUpdated: state => state.consumerLoanTransaction.channelUpdate,
        cxLoanInvUpdated: state => state.consumerLoanInventory.channelUpdate,
        branches: state => state.branchLocation.list,
      }),
      branchName () {
        return this.branches.find(e => e.id === this.storeId).name
      },
      storeId () {
        return this.$route.params.storeId
      },
      loadingServerSideData () {
        return this.cxLoanTxnLoading ||
          this.saleInvLoading ||
          this.lostInvLoading ||
          this.rcvInvLoading ||
          this.cxLoanInvLoading ||
          this.expenseGetting
      },
      rangeSales () {
        const debit = this.saleInvList.reduce((t, c) => t + c.tamount, 0)
        const credit = this.rangeLoanLent
        return debit + credit
      },
      rangeExpenses () {
        return this.expenseList.reduce((t, c) => t + c.tamount, 0)
      },
      rangeRecieved () {
        return this.rcvInvList.reduce((t, c) => t + c.tamount, 0)
      },
      rangeLoanPaid () {
        return this.cxLoanTxnList.reduce((t, c) => t + c.tamount, 0)
      },
      // rangePurchases () {
      //   return this.purchases.reduce((t, c) => t + c.tamount, 0)
      // },
      netProfit () {
        return this.rangeSales - (this.rangeRecieved + this.rangeExpenses)
      },
      rangeLoanLent () {
        return this.cxLoanInvList.reduce((t, c) => t + c.tamount, 0)
      },
      collectibles () {
        return this.rangeLoanLent - this.rangeLoanPaid
      },
    },
    watch: {
      lostInvUpdated () {
        switch (this.dateIntervalSelected) {
          case 0:
            this.getLostInvWeekly()
            break
          case 1:
            this.getLostInvMonthly()
            break
          case 2:
            this.getLostInvYearly()
            break
        }
      },
      saleInvUpdated () {
        switch (this.dateIntervalSelected) {
          case 0:
            this.getSaleInvWeekly()
            break
          case 1:
            this.getSaleInvMonthly()
            break
          case 2:
            this.getSaleInvYearly()
            break
        }
      },
      rcvInvUpdated () {
        switch (this.dateIntervalSelected) {
          case 0:
            this.getRcvInvWeekly()
            break
          case 1:
            this.getRcvInvMonthly()
            break
          case 2:
            this.getRcvInvYearly()
            break
        }
      },
      cxLoanTxnUpdated () {
        switch (this.dateIntervalSelected) {
          case 0:
            this.getCxLoanTxnWeekly()
            break
          case 1:
            this.getCxLoanTxnMonthly()
            break
          case 2:
            this.getCxLoanTxnYearly()
            break
        }
      },
      cxLoanInvUpdated () {
        switch (this.dateIntervalSelected) {
          case 0:
            this.getCxLoanInvWeekly()
            break
          case 1:
            this.getCxLoanInvMonthly()
            break
          case 2:
            this.getCxLoanInvYearly()
            break
        }
      },
      dateIntervalSelected () {
        this.getGraphData()
      },
      storeId () {
        this.getGraphData()
      },
      graphDate () {
        this.getGraphData()
      },
      expenseCategory () {
        this.getExpense()
      },
    },
    methods: {
      ...intervalGetters('cx-loan-txn', cxLoanTxnRepository, internalGetterCallBack, 'get'),
      ...intervalGetters('cx-loan-inv', cxLoanInvRepository, internalGetterCallBack, 'get'),
      ...intervalGetters('lost-inv', lostInvRepository, internalGetterCallBack, 'get'),
      ...intervalGetters('sale-inv', saleInvRepository, internalGetterCallBack, 'get'),
      ...intervalGetters('rcv-inv', rcvInvRepository, internalGetterCallBack, 'get'),
      getGraphData () {
        const intervals = ['Weekly', 'Monthly', 'Yearly']
        const functions = ['LostInv', 'RcvInv', 'SaleInv', 'CxLoanTxn', 'CxLoanInv']
        functions.forEach(e => {
          this[`get${e}${intervals[this.dateIntervalSelected]}`](this.graphDate)
        })
        this.getExpense()
      },
      getExpense () {
        const handler = expenseGetHandler
        const repository = expenseRepository.storeIntervals
        const params = this.getGetExpenseParams()
        handler.setVue(this)
        handler.execute(repository, [params])
      },
      getExpenseCategories () {
        const handler = expenseCategoryGetHandler
        const repository = expenseCategoryRepository.index
        handler.setVue(this)
        handler.execute(repository)
      },
      getGetExpenseParams () {
        const intervals = ['weekly', 'monthly', 'yearly']
        const interval = intervals[this.dateIntervalSelected]
        const date = this.graphDate
        const { storeId } = this
        const category = this.expenseCategory
        return {
          interval,
          date,
          storeId,
          category,
        }
      },
    },
    mixins: [
      moneyMixin,
    ],
  }
</script>
